export default {
  all: [],
  current: null,
  deliveryMethods: [],
  paymentMethods: [],
};
